export const getLatestDescendantDueDate = (task) => {
  if (!task) return null;
  const dueDates = (task.subtasks || []).flatMap((subtask) => {
    const ownDate = subtask.due_date ? new Date(subtask.due_date) : null;
    const latestNestedDate = getLatestDescendantDueDate(subtask);
    return [ownDate, latestNestedDate].filter(Boolean);
  });

  if (!dueDates.length) return null;
  return new Date(Math.max(...dueDates.map((date) => date.getTime())));
};

export const cascadeDueDate = (task, dueDate) => {
  (task.subtasks || []).forEach((subtask) => {
    subtask.due_date = dueDate ? new Date(dueDate) : null;
    cascadeDueDate(subtask, dueDate);
  });
};
